import userService from "@api/userService";

const actions = {
    userRequest: ({ commit, dispatch }) => {
        commit("USER_REQUEST");

        return new Promise((resolve, reject) => {
            userService
                .getUser()
                .then(resp => {
                    commit("USER_SUCCESS", resp.data);
                    resolve(resp);
                })
                .catch(err => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit("USER_ERROR", errors);

                    // if resp is unauthorized, logout
                    return dispatch("auth/authLogout", null, { root: true }).then(() => {
                        reject(err.response);
                    });
                });
        });
    },
    userUpdate: ({ commit, dispatch }, payload) => {
        commit("USER_REQUEST");

        let data = {
            email: payload.email,
            mobile: payload.mobile,
            address: payload.address,
            suburb: payload.suburb,
            state: payload.state,
            postcode: payload.postcode,
            phone: payload.phone,
            workphone: payload.workphone,
            job: payload.job,
            height: payload.height,
            weight: payload.weight,
            ec_fullname: payload.ec_fullname,
            ec_mobile: payload.ec_mobile,
            ec_fullname_2: payload.ec_fullname_2,
            ec_mobile_2: payload.ec_mobile_2,
            ec_medical: payload.ec_medical,
            school: payload.school,
            job_title: payload.job_title,
            skills: payload.skills,
            agreed_to_terms: payload.agreed_to_terms,
            agreed_to_privacy: payload.agreed_to_privacy,
            agreed_to_indemnity: payload.agreed_to_indemnity,
            subscribed_to_newsletter: payload.subscribed_to_newsletter,
            subscribed_to_sms: payload.subscribed_to_sms,
            subscribed_to_comm: payload.subscribed_to_comm,
            sport: payload.sport,

            middlename: payload.middlename,
            prefname: payload.prefname,
            disability: payload.disability,
            disabilitytype: payload.disabilitytype,
            identifygender: payload.identifygender,
            countrybirth: payload.countrybirth,
            statebirth: payload.statebirth,
            aboriginal: payload.aboriginal,
            profilephoto: payload.profilephoto,
            profilephotosrc: payload.profilephotosrc
        };

        return new Promise((resolve, reject) => {
            userService
                .updateUser(data)
                .then(resp => {
                    commit("USER_SUCCESS", resp.data);
                    resolve(resp);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("USER_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    userEftUpdate: ({ commit, dispatch, state }, payload) => {

        return new Promise((resolve, reject) => {
            commit("USER_REQUEST");

            userService.eftUpdate(payload.account_name, payload.account_bsb, payload.account_number)
            .then((resp) => {
                commit('USER_SUCCESS', resp.data);
                resolve(resp);
            })
            .catch((err) => {
                let errors = err.response.data;

                commit('USER_ERROR', errors);
                reject(err.response);
            });
        })
    },
};

export default actions;
